module.exports = __webpack_public_path__ + "img/code.8ba3a752.gif";